import { PaginatedResponse, PaginationParams } from '@console/utils';
import { apiClient } from './client';

export interface Group {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateGroupDto {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateGroupDto {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export const groupsApi = {
  getAll: async (params?: PaginationParams): Promise<PaginatedResponse<Group>> => {
    const queryString = params
      ? `?${new URLSearchParams({
          ...(params.page && { page: params.page.toString() }),
          ...(params.limit && { limit: params.limit.toString() }),
        }).toString()}`
      : '';
    const response = await apiClient.get(`/groups${queryString}`);
    return response.data;
  },

  getAllForSelect: async (): Promise<Array<{ id: string; name: string }>> => {
    const response = await apiClient.get('/groups/select/all');
    return response.data;
  },

  getById: async (id: string): Promise<Group> => {
    const response = await apiClient.get(`/groups/${id}`);
    return response.data;
  },

  create: async (data: CreateGroupDto): Promise<Group> => {
    const response = await apiClient.post('/groups', data);
    return response.data;
  },

  update: async (id: string, data: UpdateGroupDto): Promise<Group> => {
    const response = await apiClient.patch(`/groups/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/groups/${id}`);
  },
};
